import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import unescapedText from 'I18n/utils/unescapedText';
import styled from 'styled-components';
import { getRefreshUrl } from '../helpers/getRefreshUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const POPOVER_ILLUSTRATION_WIDTH = 130;
const StyledErrorMessage = styled(UIErrorMessage).withConfig({
  displayName: "UniversalAssociationsSelectError__StyledErrorMessage",
  componentId: "sc-1rlnkhp-0"
})(["img{margin-bottom:16px;}"]);
const UniversalAssociationsSelectError = () => {
  return /*#__PURE__*/_jsx(StyledErrorMessage, {
    className: "m-top-4 m-right-10 m-bottom-4 m-left-10",
    illustrationProps: {
      width: POPOVER_ILLUSTRATION_WIDTH
    },
    title: unescapedText('universalAssociationsSelect.errorSorry'),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link
      },
      message: "universalAssociationsSelect.error_jsx",
      options: {
        href: getRefreshUrl()
      }
    })
  });
};
export default UniversalAssociationsSelectError;